import React, { useState, useEffect } from "react"
import Spin from "images/inline/breaktime-spinner.svg"
import { CSSTransition } from "react-transition-group"
import PropTypes from "prop-types"
import "./Spinner3.scss"

//
// Implements the loading spinner in a slick, css-transition-y way.
// Wrapping content that will change and "load" with <LoadingContainer> and passing it the prop condition (boolean: true for is loading),
// and toggling true/false, will transition the child content gracefully between the two states.
//

const SpinnerContainer = ({ active, children }) => {
  const animationDuration = 200
  return (
    <div className={`breaktime-logo-spinner loading-spinner--wrapper will-fade-transition-container`}>
      <CSSTransition className={`loading-spinner will-fade-transition ${active ? `is-active` : `is-inactive`}`} in={active} timeout={animationDuration} unmountOnExit={false}>
        <div>
          <Spin />
        </div>
      </CSSTransition>
      <CSSTransition className={`spinner-content loading-spinner-content will-fade-transition ${!active ? `is-active` : `is-inactive`}`} in={!active} timeout={animationDuration} unmountOnExit={false}>
        <div>{children}</div>
      </CSSTransition>
    </div>
  )
}
SpinnerContainer.propTypes = {
  active: PropTypes.bool,
}

SpinnerContainer.defaultProps = {
  active: false,
}
export default SpinnerContainer
